import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Notification } from "../../../app/app.interfaces";
import { AuthService } from "../../../services/auth.service";
import { EventService } from "../../../services/event.service";

@Component({
  selector: 'notification-card',
  templateUrl: 'notification-card.html'
})


export class NotificationCard implements OnInit {

	@Input() notification: Notification;
  @Output() markAsRead: EventEmitter<void> = new EventEmitter<void>();

  constructor(public authService: AuthService,
							private eventService: EventService
  ) {
  }

  ngOnInit(): void {
    if(this.notification && this.notification.navigationParams) this.notification.navigationParams.push = true;
  }

  cardClicked(): void{
  	this.eventService.notificationDropdownItemClicked.emit();
		this.markAsRead.emit()
	}


}




// WEBPACK FOOTER //
// ./src/partials/notification/notification-card/notification-card.ts